export default "__VITE_ASSET__CpMiMq53__"